import {call, put} from "redux-saga/effects";
import { setProducts} from "../actions";
import {getProducts} from "../../firebase/methods";


const requestGetProducts = (filters) => {
    return getProducts(filters);
}

export function* handleGetProducts(action){
    try {
        const {filters} = action.payload;
        const response = yield call(()=>requestGetProducts(filters));
        let data = [];
        response.docs.forEach(doc => {
            data.push(doc.data());
        });
        yield put(setProducts(data));
    }
    catch (error) {
        console.log(error)
    }
}